import React from 'react';
import Icon from '../../../components/AppIcon';

const OccupancyMonitor = ({ currentOccupancy }) => {
  const maxCapacity = 100; // Default max capacity
  const occupancyPercentage = Math?.min(Math?.round((currentOccupancy / maxCapacity) * 100), 100);

  const getOccupancyStatus = () => {
    if (occupancyPercentage >= 90) return { label: 'At Capacity', color: 'text-destructive', bgColor: 'bg-destructive/10' };
    if (occupancyPercentage >= 70) return { label: 'High', color: 'text-warning', bgColor: 'bg-warning/10' };
    if (occupancyPercentage >= 40) return { label: 'Moderate', color: 'text-success', bgColor: 'bg-success/10' };
    return { label: 'Low', color: 'text-muted-foreground', bgColor: 'bg-muted' };
  };

  const status = getOccupancyStatus();

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg font-semibold text-foreground mb-1">Real-Time Occupancy</h2>
          <p className="text-sm text-muted-foreground">Current members in facility</p>
        </div>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full ${status?.bgColor}`}>
          <div className="w-2 h-2 rounded-full bg-current animate-pulse" />
          <span className={`text-sm font-semibold ${status?.color}`}>{status?.label}</span>
        </div>
      </div>

      <div className="flex items-center justify-center mb-6">
        <div className="relative">
          <div className="w-48 h-48 rounded-full border-8 border-muted flex items-center justify-center">
            <div className="text-center">
              <p className="text-5xl font-bold text-foreground mb-1">{currentOccupancy}</p>
              <p className="text-sm text-muted-foreground">members</p>
            </div>
          </div>
          <svg className="absolute top-0 left-0 w-48 h-48 -rotate-90">
            <circle
              cx="96"
              cy="96"
              r="88"
              stroke="var(--color-primary)"
              strokeWidth="8"
              fill="none"
              strokeDasharray={`${occupancyPercentage * 5.53} 553`}
              className="transition-all duration-500"
            />
          </svg>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="text-center p-3 bg-muted rounded-lg">
          <Icon name="Users" size={20} className="text-primary mx-auto mb-2" />
          <p className="text-lg font-bold text-foreground">{currentOccupancy}</p>
          <p className="text-xs text-muted-foreground">Current</p>
        </div>
        <div className="text-center p-3 bg-muted rounded-lg">
          <Icon name="Target" size={20} className="text-success mx-auto mb-2" />
          <p className="text-lg font-bold text-foreground">{maxCapacity}</p>
          <p className="text-xs text-muted-foreground">Capacity</p>
        </div>
        <div className="text-center p-3 bg-muted rounded-lg">
          <Icon name="Percent" size={20} className="text-warning mx-auto mb-2" />
          <p className="text-lg font-bold text-foreground">{occupancyPercentage}%</p>
          <p className="text-xs text-muted-foreground">Utilization</p>
        </div>
      </div>

      <div className="mt-4 p-3 bg-muted rounded-lg">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Updates in real-time as members check in and out</span>
        </div>
      </div>
    </div>
  );
};

export default OccupancyMonitor;